<template>
    <div
        class="truncate"
        :class="{ 'include-desktop': !mobileOnly, expanded, 'pb-0': hideTruncate }"
        :style="{ maxHeight: !expanded ? maxHeightWithButton : 'none' }"
        ref="truncate"
    >
        <slot></slot>
        <media-only v-if="!hideTruncate" :mobile="mobileOnly">
            <div class="truncate-button-wrapper">
                <button type="button" @click="expanded = !expanded" class="truncate-button">
                    <translate v-if="expanded" path="Generic.showLess" />
                    <translate v-else path="Generic.showMore" />
                </button>
            </div>
        </media-only>
    </div>
</template>

<script>
export default {
    name: 'Truncate',
    data() {
        return {
            expanded: false,
            hideTruncate: false,
            buttonBlockHeight: 36
        };
    },
    props: {
        maxHeight: {
            type: Number,
            default: 72 //3 lines  * 24px line height
        },
        mobileOnly: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        maxHeightWithButton() {
            return `${this.maxHeight + this.buttonBlockHeight}px`;
        }
    },
    methods: {
        getHeight() {
            const truncateEl = this.$refs.truncate;
            const clone = truncateEl.cloneNode(true);
            clone.style.position = 'absolute';
            clone.style.left = '-9999px';
            document.body.append(clone);
            const height = clone.offsetHeight;
            clone.remove();
            return height;
        }
    },
    watch: {
        async expanded(expanded) {
            await this.$nextTick();
            if (!expanded) {
                try {
                    const el = this.$refs.truncate;
                    const yOffset = -100;
                    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y });
                } catch (e) {}
            } else {
                try {
                    const el = this.$refs.truncate;
                    const swiper = el.closest('.swiper-wrapper');
                    if (swiper) {
                        swiper.style.height = 'auto';
                    }
                } catch (e) {}
            }
        }
    },
    mounted() {
        const overallHeight = this.getHeight();
        /* if (!overallHeight) {
            return false;
        }
        */ this.hideTruncate = overallHeight - this.buttonBlockHeight < this.maxHeight;
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/bootstrap/breakpoints' as breakpoints;
@use '@/styles/theming' as *;
@use '@/styles/mixins';

.truncate {
    @include mixins.desktop-only {
        &:not(.include-desktop) {
            max-height: none !important;
        }
    }

    &:not(.expanded) {
        overflow: hidden;
    }

    @mixin truncate-rules {
        padding-bottom: 36px;
        position: relative;

        .truncate-button-wrapper {
            position: absolute;
            bottom: -1px; //prevents from showing the bottom pixel line
            left: 0;
            width: 100%;
            padding-top: 10px;
            text-align: center;
            z-index: 7;

            background-image: linear-gradient(to bottom, hsla(0, 0%, 100%, 0), var(--white) 70%);

            .truncate-button {
                color: var(--primary);
                outline: none;
                background: none;
                border: none;
                padding-left: 0;
                font-weight: bold;
            }
        }
    }

    @include breakpoints.media-breakpoint-down(variables.$mobile-breakpoint-max) {
        @include truncate-rules;
    }

    &.include-desktop {
        @include truncate-rules;
    }
}
</style>
